import { BASE_URL } from '../constants'
const token = JSON.parse(localStorage.getItem('token'))
const userInfoStorage = JSON.parse(localStorage.getItem('user-info'))

export const savePersonalInformation = async ({
  dni,
  phone,
  codePhone,
  country,
  state,
  city,
  names,
  surnames,
  linkedin,
  birthday,
}) => {
  const customDataTalent = {
    account: {
      names,
      surnames,
      dni,
      phone,
      birthday,
      codePhone,
    },
    address: {
      country,
      state,
      city,
    },
    socialNetworks: {
      linkedin,
    },
  }
  const customDataRecruiter = {
    account: {
      names,
      surnames,
      dni,
      phone,
      birthday: '2023-07-11',
    },
    address: {
      country,
      state,
      city,
    },
    socialNetworks: {},
  }
  const rawBody = JSON.stringify(
    userInfoStorage?.payload?.typeUser === 1
      ? customDataTalent
      : customDataRecruiter
  )

  const URL = `${BASE_URL}/uploadinfotalent`

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const saveProfessionalInformation = async (data) => {
  const URL = `${BASE_URL}/setinfoprofessionalstalent`
  const rawBody = JSON.stringify(data)

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const addskilltalent = async (data) => {
  const URL = `${BASE_URL}/addskilltalent`
  const rawBody = JSON.stringify({ ...data })

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const deleteSkilltalent = async (data) => {
  const URL = `${BASE_URL}/deleteskill/${data?.id}`

  try {
    const res = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const addLanguageTalent = async (data) => {
  const URL = `${BASE_URL}/addlangtalent`

  const rawBody = JSON.stringify(data)

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const deleteLanguageTalent = async (data) => {
  const URL = `${BASE_URL}/deletelangtalent/${data?.id}`

  try {
    const res = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const addWorksTalent = async ({ works = [] }) => {
  const URL = `${BASE_URL}/addworkstalent`

  const rawBody = JSON.stringify({ works })

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const updateWorkExperience = async (data) => {
  const URL = `${BASE_URL}/updatework`

  const rawBody = JSON.stringify({ ...data })

  try {
    const res = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const uploadPDF = async ({ pdf }) => {
  const URL = 'https://pdf-service-oline.up.railway.app/upload'

  const formData = new FormData()
  formData.append('file', pdf)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        Authorization:
          'Basic aHV0cml0OldNekY4RHIzNzhINjQ0SXMyMk1KN1E2UmtIVDJSWg==',
      },
      body: formData,
    })
    const data = await response.json()
    return { response, data }
  } catch (error) {
    console.error('Error uploading PDF:', error)
  }
}

export const uploadGenericPDF = async ({ pdf }) => {
  const URL = `${BASE_URL}user/readerCv/readerOne`

  const formData = new FormData()
  formData.append('cv', pdf)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const data = await response.json()
    return { response, data }
  } catch (error) {
    console.error('Error uploading PDF:', error)
  }
}

export const updateStudies = async (data) => {
  const URL = `${BASE_URL}updateStudies`

  const rawBody = JSON.stringify({ ...data })

  try {
    const res = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const updateCertifications = async (data) => {
  const URL = `${BASE_URL}updateCertifications`

  const rawBody = JSON.stringify({ ...data })

  try {
    const res = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const uploadPdfAndRegisterTalent = async ({ pdf }) => {
  const URL = `${BASE_URL}user/reader/cv/uploadFilesRecruiter`

  const formData = new FormData()
  const filesArray = Array.from(pdf);
  filesArray.forEach(file => formData.append('files', file));

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })
    const data = await response.json()
    return { response, data }
  } catch (error) {
    console.error('Error uploading PDF:', error)
  }
}

export const listUploadFilesRecruiter = async ({ page = 0, pageSize = 10 } = {}) => {
  const URL = `${BASE_URL}user/listUploadFilesRecruiter/cv?page=${page}&pageSize=${pageSize}&reading`;

  try {
    const response = await fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    });
    const data = await response.json();
    return { response, data };
  } catch (error) {
    console.log(error);
  }
};
